<template>
    <div class="recent-daily-report-box">
        <h3 class="recent-head-title">近期知识日报</h3>

        <div class="recent-dailys">
            <section class="recent-daily-item" v-for="(daily, index) in dailyList" @click="setDailyRead(daily.ReleaseId, index)">
                <div class="daily-head flexBox">
                    <h5 class="flexBox">
                        <span v-text="daily.Name"></span>
                        <img class="head-icon" src="/static/images/icon/NEW.svg" v-if="!daily.IsRead && index === 0  && $store.state.global.newDaily">
                    </h5>
                    <span class="blank flexItem"></span>
                    <span class="right-arrow"></span>
                </div>
                <div class="daily-body">
                    <p v-html="daily.Description.replace(/[\n↵]/g, `<span class='mt-20'></span>`)"></p>
                </div>
                <div class="analyse-info">
                    <span>{{ daily.TotalViewCount | validCount }}人浏览</span>
                </div>
            </section>
        </div>

        <div class="recent-bottom-tips">
            最多显示近两周的知识更新日报
        </div>
    </div>
</template>

<script>
    import { HOME, COMMON } from '@/api'
    export default {
        name: 'recentDailyReport',
        NIODesc: '近期知识日报页面',
        data() {
            return {
                dailyList: [
                    // {
                    //     Description: "今日重点↵1. 更新大客户员工优惠短期操作方案↵2. 企业新闻：二季度毛利率将转正 蔚来开启高效能模式↵3. 企业新闻：蔚来汽车降本增效初见成效：2020毛利有望转正，老用户推荐率达69%↵4. 新增博园路停车场地图",
                    //     IsRead: false,
                    //     LinkUrl: "https://helpcenter.niohome.com/#/latestDetail/444a2ba5-6f79-4c35-96fd-a4b9e8c6a618",
                    //     Name: "知识更新日报 20200320",
                    //     ReleaseId: "444a2ba5-6f79-4c35-96fd-a4b9e8c6a618",
                    //     TotalViewCount: 0
                    // }
                ]
            }
        },
        mounted() {
            this.GetRecentDailys()
        },
        methods: {
            GetRecentDailys() {
                COMMON.GetRecentDailys().then( (res) => {
                    if (res.Code === 200 && res.Data && res.Data.List) {
                        this.dailyList = res.Data.List
                    }
                })
            },
            setDailyRead(ReleaseId, index) {
                // HOME.SetRead({
                //     ReleaseId: ReleaseId
                // }).then( (res) => {
                //     if(res.Code === 200){
                //         // 去除 NEW 图标
                //         this.dailyList[index].IsRead = true
                //     }
                // })

                if (index === 0) {
                    // 设置最新一条已读
                    // 利用vuex标识已读 首页【近期知识日报】的NEW标志由此控制
                    this.$store.commit('NEWDAILY', false)
                }
                
                // 跳转详情页
                this.$router.push({
                    name: 'latestDetail',
                    params: {
                        uuid: ReleaseId
                    }
                })
            }
        }
    }
</script>

<style lang='scss' scoped>
    .recent-daily-report-box {
        padding: 0 j(50);
    }
    .recent-head-title {
        padding-top: j(60);
        padding-bottom: j(100);
        font-size: j(60);
        font-weight: bold;
        color: #363c54;
    }
    .recent-daily-item {
        position: relative;
        padding-bottom: j(60);
        &:after {
            @include thin-bb(#f0f1f2);
        }
        & + & {
            margin-top: j(60);
        }
    }
    .daily-head {
        height: j(50);
        h5 {
            font-weight: bold;
            font-size: j(36);
            color: #363c54;
            justify-content: center;
        }
        .head-icon {
            width: j(70);
            margin-left: j(10);
        }
        .right-arrow {
            display: inline-block;
            width: j(15);
            height: j(15);
            border-top: 1px solid #9b9da9;
            border-right: 1px solid #9b9da9;
            transform: rotate(45deg) translate(-3px, 3px);
        }
    }
    .daily-body {
        margin-top: j(30);
        font-size: j(28);
        color: #696d7f;
        p:not(:empty) {
            margin-top: j(20);
        }
        p /deep/ .mt-20 {
            display: block;
            margin-top: j(20);
        }
    }
    .analyse-info {
        margin-top: j(30);
        font-size: j(24);
        color: #9B9DA9;
    }
    .recent-bottom-tips {
        margin: j(60) 0;
        font-size: j(28);
        color: #9b9da9;
        text-align: center;
        @include iphoneX () {
            border-bottom: 34px solid transparent;
        }
    }
</style>


// WEBPACK FOOTER //
// src/views/recentDailyReport.vue